import { Link, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useWorkspacePath } from '../lib/workspaceRoutes';

const FIX_VIEWS = [
  { label: 'Warnings', path: '/admin/quality/findings' },
  { label: 'Accounts', path: '/admin/quality/identity?view=account-candidates' },
  { label: 'People', path: '/admin/quality/identity?view=people' },
  { label: 'Missing ratings', path: '/admin/quality/engagement' },
];

export function AdminShell() {
  const { pathname } = useLocation();
  const workspaceTo = useWorkspacePath();
  const [params] = useSearchParams();
  const root = workspaceTo('/admin');
  const onHistory = pathname === `${root}/history`;
  const onReviewLater = pathname === `${root}/review-later`;
  const onUploads = pathname === root || /\/(intake\/reviews|add-files|ingestions\/[^/]+|batches\/[^/]+)$/.test(pathname);
  const fix = pathname.startsWith(`${root}/quality/`) && !pathname.endsWith('heatmap-import')
    && params.get('view') !== 'imported-matches';
  const feedback = pathname.startsWith(`${root}/feedback/`);
  const links = fix ? FIX_VIEWS : feedback ? [
    {label: 'Data corrections', path: '/admin/feedback/field-intel'},
    {label: 'Product ideas', path: '/admin/feedback/ideas'},
  ] : [];
  return (
    <div className="admin-shell min-w-0">
      <div className="border-b border-[var(--color-brand-line)] bg-[var(--color-brand-bg)]">
        <div className="mx-auto max-w-[1100px] px-4 sm:px-6">
          <nav aria-label="Admin" className="flex flex-wrap items-center gap-x-6 gap-y-1 py-2">
            {[{label: 'Uploads', path: '/admin', active: onUploads},
              {label: 'Review later', path: '/admin/review-later', active: onReviewLater},
              {label: 'History', path: '/admin/history', active: onHistory},
              {label: 'Other admin work', path: '/admin/other', active: !onUploads && !onHistory && !onReviewLater}].map(item => (
              <Link key={item.path} to={workspaceTo(item.path)} aria-current={item.active ? 'page' : undefined}
                className={`inline-flex min-h-10 items-center text-sm focus-visible:outline-2 focus-visible:outline-offset-4 ${item.active ? 'font-semibold text-white underline underline-offset-8' : 'text-[var(--text-secondary)] hover:text-white'}`}>
                {item.label}
              </Link>
            ))}
          </nav>
          {links.length > 0 && <nav aria-label={fix ? 'Fix data' : 'Feedback'} className="flex flex-wrap gap-5 border-t border-[var(--color-brand-line)] py-3">
            {links.map(item => {
              const active = pathname === workspaceTo(item.path.split('?')[0]) && (!item.path.includes('?') || item.path.endsWith(`view=${params.get('view') ?? 'account-candidates'}`));
              return <Link key={item.path} to={workspaceTo(item.path)} aria-current={active ? 'page' : undefined} className={`min-h-9 text-sm ${active ? 'font-semibold text-white' : 'text-[var(--text-secondary)]'}`}>{item.label}</Link>;
            })}
          </nav>}
        </div>
      </div>
      <div className="min-w-0 max-sm:pb-12"><Outlet /></div>
    </div>
  );
}
